import { MaxParamThresholds } from './getMaxAmountOpen'

/**
 * Compute the maximum dollar amount for closing (deleveraging) a position
 * without dropping the health factor below `SAFE_HF`.
 *
 * A close operation withdraws $X of collateral and repays $X of debt.
 *   BDC decreases by `ltvIn * X`
 *   adjustedDebt decreases by `bfOut * X`
 *
 * If `ltvIn <= SAFE_HF * bfOut`, the close always improves health
 * → returns Infinity (capped by position size upstream).
 *
 * @param borrowDiscountedCollateral  Current risk-adjusted collateral
 * @param adjustedDebt               Current risk-adjusted debt
 * @param ltvIn   borrowCollateralFactor of the collateral being withdrawn
 * @param bfOut   borrowFactor of the debt being repaid
 * @returns Maximum dollar amount that can be closed
 */
export function getMaxAmountClose(
  borrowDiscountedCollateral: number,
  adjustedDebt: number,
  ltvIn: number,
  bfOut: number,
): number {
  const denominator = ltvIn - MaxParamThresholds.SAFE_HF * bfOut
  // If collateral removal hurts less than debt removal helps, close always improves
  if (denominator <= 0) return Infinity

  return (
    (borrowDiscountedCollateral - MaxParamThresholds.SAFE_HF * adjustedDebt) /
    denominator
  )
}
